import { render, staticRenderFns } from "./ToggleRewardsModal.vue?vue&type=template&id=18d2af0a&scoped=true&"
import script from "./ToggleRewardsModal.vue?vue&type=script&lang=ts&"
export * from "./ToggleRewardsModal.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleRewardsModal.vue?vue&type=style&index=0&id=18d2af0a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d2af0a",
  null
  
)

export default component.exports